import request from '@/utils/request'

export function getSystemSettings() {
  return request({
    url: '/api/System/setting',
    method: 'get',
    timeout: 3 * 60 * 1000
  })
}

export function loginAuto(code) {
  return request({
    url: '/api/Account/AutoLogin?code=' + encodeURIComponent(code),
    method: 'get',
    timeout: 3 * 60 * 1000
  })
}

export function createLoginSign() {
  return request({
    url: '/api/Account/CreateLoginSign',
    method: 'post',
    timeout: 3 * 60 * 1000
  })
}

export function checkLoginSign(loginSign) {
  return request({
    url: '/api/Account/CheckLoginSign?loginSign=' + encodeURIComponent(loginSign),
    method: 'get',
    timeout: 3 * 60 * 1000
  })
}

export function getTokenByLoginSign(loginSign) {
  return request({
    url: '/api/Account/GetTokenByLoginSign?loginSign=' + encodeURIComponent(loginSign),
    method: 'get',
    timeout: 3 * 60 * 1000
  })
}

export function addTuModelClickLog(type) {
  return request({
    url: `/api/Account/AddTuModelClickLog?type=${type}`,
    method: 'post'
  })
}

export function AddTutorClientDownloadsLog(sourceType, clientInfo, clientType) {
  return request({
    url: '/api/Account/AddTutorClientDownloadsLog',
    method: 'post',
    data: {
      SourceType: sourceType,
      ClientInfo: clientInfo,
      ClientType: clientType
    }
  })
}
